module.exports = __webpack_public_path__ + "324da9aa9e999a97cabd5d98ce230903.jpg";